import React from "react";

import AddEditForm from "../AddEditForm/View";

const AddSupplier = ({ supplierState, actions, brands }) => {
  return (
    <AddEditForm brands={brands} isAddSupplier={true} supplierState={null} actions={actions} />
  );
};

export default AddSupplier;
